import { ChevronRight } from 'lucide-react'
import { copy } from '../../copy/investor-copy'
import { useBrowseStartups } from '../../hooks/use-investor-assistant'

/** "Browse all N startups"; always shown, the count once it is known. Its own query, so browse mode does not fetch it. */
export function BrowseAllLink({ onBrowse }: { onBrowse: () => void }) {
  const total = useBrowseStartups({}).data?.pages[0]?.total
  return (
    <button
      type="button"
      onClick={onBrowse}
      className="mt-3 inline-flex items-center gap-1 text-xs text-muted-foreground transition-colors hover:text-foreground"
    >
      {total === undefined
        ? copy('search.browseAll.plain')
        : copy('search.browseAll', { n: total })}
      <ChevronRight className="size-3.5" />
    </button>
  )
}
